import { useParams } from 'react-router-dom'
import { thermostatsCollection } from '@/reducers/thermostats'
import { thermostatSettingsCollection } from '@/reducers/thermostatSettings'
import { thermostatComfortSettingsCollection } from '@/reducers/thermostatComfortSettings'
import { getGridSupportSettingsSummary } from '@/app/pages/utility-program/unenroll/suggestions/components/ThermostatSuggestionCard/ThermostatSuggestionCard.utils'
import { unenrollmentThermostatDisplayName } from '@/app/pages/utility-program/unenroll/utils'
import { Thermostat, ThermostatSettings } from '@/types'

export default function useConfigureThermostatViewModel() {
  const { deviceId } = useParams<{ deviceId: string }>()
  const thermostatId = Number(deviceId)

  const { data: thermostats, isLoadingOrIdle: thermostatsLoading } =
    thermostatsCollection.useFetch()
  const thermostat = thermostats.find((t) => t.id === thermostatId) as
    | Thermostat
    | undefined

  const { data: settingsArray, isLoadingOrIdle: settingsLoading } =
    thermostatSettingsCollection.useFetch(
      `/thermostats/${thermostatId}/settings/`,
    )
  const settings = settingsArray[0] as ThermostatSettings | undefined

  const { data: comfortSettings, isLoadingOrIdle: comfortSettingsLoading } =
    thermostatComfortSettingsCollection.useFetch(
      `/thermostats/${thermostatId}/comfort_settings/`,
    )

  const isLoadingOrIdle =
    thermostatsLoading ||
    settingsLoading ||
    comfortSettingsLoading ||
    !thermostat

  const displayName = thermostat
    ? unenrollmentThermostatDisplayName(thermostat)
    : ''

  const gridSupportSummary = thermostat
    ? getGridSupportSettingsSummary(comfortSettings, thermostat)
    : []

  // Save Money (cost category control / TOU pre-cool) is intentionally not
  // configurable from post-application setup (DEV-6567) — it lives on the
  // device Settings tab.
  const settingPaths = {
    eventTemperatures: `/devices/thermostat/${thermostatId}/event-temperatures`,
  }

  return {
    isLoadingOrIdle,
    thermostat,
    displayName,
    settingPaths,
    gridSupportEnabled: settings?.grid_support_enabled ?? false,
    gridSupportSummary,
  }
}
